import { DefaultChain } from 'utils/chains'

export default () => {
  return DefaultChain
}
